module.exports = __webpack_public_path__ + "files/96696431481097e710e260697d9e355d.png";